import { HelmetProvider } from "react-helmet-async";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import Cookies from "./pages/Cookies";
import Ratgeber from "./pages/Ratgeber";
import RatgeberErkaeltung from "./pages/RatgeberErkaeltung";
import RatgeberFieber from "./pages/RatgeberFieber";
import RatgeberKopfschmerzen from "./pages/RatgeberKopfschmerzen";
import RatgeberSchlafprobleme from "./pages/RatgeberSchlafprobleme";
import RatgeberAbnehmen from "./pages/RatgeberAbnehmen";
import RatgeberGrippe from "./pages/RatgeberGrippe";
import RatgeberHusten from "./pages/RatgeberHusten";
import RatgeberHalsschmerzen from "./pages/RatgeberHalsschmerzen";
import RatgeberVerdauung from "./pages/RatgeberVerdauung";
import RatgeberStress from "./pages/RatgeberStress";
import RatgeberImmunsystem from "./pages/RatgeberImmunsystem";
import RatgeberGelenkschmerzen from "./pages/RatgeberGelenkschmerzen";
import RatgeberAllergie from "./pages/RatgeberAllergie";
import RatgeberMuedigkeit from "./pages/RatgeberMuedigkeit";
import RatgeberHautprobleme from "./pages/RatgeberHautprobleme";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ErrorBoundary>
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/agb" element={<AGB />} />
              <Route path="/cookies" element={<Cookies />} />
              {/* Ratgeber SEO Pages */}
              <Route path="/ratgeber" element={<Ratgeber />} />
              <Route path="/ratgeber/erkaeltung" element={<RatgeberErkaeltung />} />
              <Route path="/ratgeber/fieber" element={<RatgeberFieber />} />
              <Route path="/ratgeber/kopfschmerzen" element={<RatgeberKopfschmerzen />} />
              <Route path="/ratgeber/schlafprobleme" element={<RatgeberSchlafprobleme />} />
              <Route path="/ratgeber/abnehmen" element={<RatgeberAbnehmen />} />
              <Route path="/ratgeber/grippe" element={<RatgeberGrippe />} />
              <Route path="/ratgeber/husten" element={<RatgeberHusten />} />
              <Route path="/ratgeber/halsschmerzen" element={<RatgeberHalsschmerzen />} />
              <Route path="/ratgeber/verdauung" element={<RatgeberVerdauung />} />
              <Route path="/ratgeber/stress" element={<RatgeberStress />} />
              <Route path="/ratgeber/immunsystem" element={<RatgeberImmunsystem />} />
              <Route path="/ratgeber/gelenkschmerzen" element={<RatgeberGelenkschmerzen />} />
              <Route path="/ratgeber/allergie" element={<RatgeberAllergie />} />
              <Route path="/ratgeber/muedigkeit" element={<RatgeberMuedigkeit />} />
              <Route path="/ratgeber/hautprobleme" element={<RatgeberHautprobleme />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </ErrorBoundary>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
